import { ReactNode } from "react";
import { Container } from "@mui/material";

type Props = {
  children: ReactNode;
}

const CenterContainer: React.FC<Props> = ({ children }) => {
  return (
    <Container maxWidth="sm">
      {children}
    </Container>
  );
};

export default CenterContainer;
